// Same endpoints the mobile Partner Network / Customers screens use (ahd-mobile/src/screens/partner/network, /customer)
export const NETWORK_ENDPOINTS = {
  partners: "/user/network/all",
  searchUsers: "/admin/users/searchByContact",
  addPartner: "/user/network/add",
  editPartner: "/user/network/edit",
  removePartner: (id) => `/user/network/delete/${id}`,
  rewardAddPartner: "/customer/rewards/user/ADD_PARTNER",

  clients: "/user/contact/all",
  addClient: "/user/contact/add",
  editClient: "/user/contact/edit",
  removeClient: (id) => `/user/contact/delete/${id}`,
  rewardAddClient: "/customer/rewards/user/ADD_CONTACT",

  countries: "/admin/countries",
  states: (countryId) => `/admin/states/${countryId}`,
  cities: (stateId) => `/admin/cities/${stateId}`,
};

export const PARTNERS_HOME = "/partner/network/partners";
export const CLIENTS_HOME = "/partner/network/clients";

export const NETWORK_PAGE_SIZE = 12;
// The list endpoints have no search or filters, so every page is fetched once and filtered locally
export const NETWORK_FETCH_PAGE_SIZE = 100;
export const NETWORK_MAX_PAGES = 50;

// Mobile searches on every keystroke (even an empty one, which lists every partner). The web waits for a
// real keyword instead.
export const SEARCH_MIN_CHARS = 3;
export const SEARCH_DEBOUNCE_MS = 500;
